import PropTypes from 'prop-types';

import Collapse from 'shopper/components/Collapse';

import TextWithRichContent from 'components/TextWithRichContent';

const FaqItem = ({ className, text, title }) => (
  <Collapse className={className} title={title} full>
    <TextWithRichContent>{text}</TextWithRichContent>
  </Collapse>
);

FaqItem.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default FaqItem;
